<template>
  <div class="main-container" :class="colorMode === 'dark' ? 'dark-block' : ''">
    <h2>Need financing to support your business growth?</h2>
    <p>
      Asoko provides opportunities to companies seeking solutions to their financial, development, sustainability, and growth needs.
    </p>
    <div class="action-wrap">
      <a
        @click="openLink"
        class="cta-button"
        :class="colorMode === 'light' ? 'medium-button' : ''"
        >Opportunities for African Businesses</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'de-tdb',
  props: {
    colorMode: {
      type: String,
    },
  },
  methods: {
    openLink() {
      this.$ga.event({
        eventCategory: 'Click',
        eventAction: 'Conversion',
        eventLabel: 'DE TDB Block',
      })
      this.$gtag.event('Conversion', {
        'event_category': 'Click',
        'event_label': 'DE TDB Block',
      })
      this.$router.push({ path: '/about/deals' })
    },
  },
}
</script>
